import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { ConfirmationService, MenuItem, TreeNode } from "primeng/api";
import { Observable, Subscription, combineLatest, debounceTime, filter } from "rxjs";
import { BoardUser, getBoardUserIcon, kbCodeToHumanReadable } from "src/app/model/board-user";
import { BoardUsersTree } from "../board-users/board-users-tree";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/app.reducer";
import { selectAcquiredBoardUser, selectBoardUserDeleted, selectBoardUsersDeleted, selectBoardUsersItemsPagination, selectBoardUsersLoading, selectBoardUsersTaskRunning, selectConnectedAutomationsCommands, selectCurrentDevice, selectCurrentDeviceBoardUsers, selectCurrentDeviceBoardUsersInfo, selectCurrentDeviceCommands, selectCurrentDeviceFeatures, selectCurrentDeviceInfo, selectCurrentDeviceModel, selectCurrentDeviceStatus, selectGroupsAll, selectNeedResync, selectPasswordValid } from "src/app/store/device/device.selector";
import { DeviceModel } from "src/app/model/device-model";
import { BOARD_USERS_DEFAULT_PAGE_SIZE, BOARD_USERS_PAGE_SIZE_OPTIONS, ECodeTypes } from "src/app/conf/board-users";
import { PaginationParams } from "src/app/model/api/pagination-params";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { BoardUsersInfo } from "src/app/model/board-users-info";
import { EDeviceModel } from "src/app/conf/device-models";
import { Command, ConnectedAutomationsCommand } from "src/app/model/command";
import { ConnectedAutomations, Device } from "src/app/model/device";
import { BoardUsersListsRespData, ItemsPagination } from "src/app/model/api/data-rest";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { TranslateService } from "@ngx-translate/core";
import { BoardUserDialogComponent } from "../board-user-dialog/board-user.dialog.component";
import { StandardDesignParameters, StandardMtmaLayout, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { AcquireBoardUserDialogComponent } from "../acquire-board-user-dialog/acquire-board-user.dialog.component";
import { DeviceStatus } from "src/app/model/device-status";
import { CAGroup } from "src/app/model/control-access";
import moment from "moment";
import { DeviceInfo } from "src/app/model/device-info";
import { MINFWVER_ACSCHEDULES_RBE24 } from "src/app/conf/control-access";
import { FormControl, FormGroup } from "@angular/forms";
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';
import { BoardUsersExportListDialogComponent } from "../board-users-export-list-dialog/board-users-export-list.dialog.component";
import { DeviceFeature } from "src/app/model/device-feature";
import { selectRoleExplainedTechnician, selectIsImpersMode } from "src/app/store/user/user.selector";
import * as DeviceBoardusersActions from 'src/app/store/device-boardusers/device-boardusers.actions';
import { selectBoardUsersListsRespData } from "src/app/store/device-boardusers/device-boardusers.selector";
import { CommonCustomConfirmDialogComponent } from "../../shared/components/common-custom-confirm-dialog/common-custom-confirm.dialog.component";

@Component({
	selector: 'app-board-users-table',
	templateUrl: './board-users-table.component.html',
	providers: [ConfirmationService, DialogService],
	styles: `
		:host ::ng-deep .accordion-bg-gray .p-accordion-content {
			background-color: var(--bluegray-700);
		}
		// :host ::ng-deep .p-treetable .p-treetable-scrollable-header,
		// :host ::ng-deep .p-treetable .p-treetable-scrollable-footer {
		// 	background-color: transparent !important;
		// }
		:host ::ng-deep .p-treetable .p-treetable-tbody > tr {
			background-color: #FFFFFF !important;
		}
	`
})

export class BoardUsersTableComponent implements OnInit, OnDestroy {
	deviceModel: DeviceModel;
	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription;
	acquiredBoardUser$: Observable<BoardUser | undefined>;
	acquiredBoardUserSub: Subscription;

	boardsList: TreeNode[];
	boards: TreeNode[];
	boardUsersTree: BoardUsersTree;
	boardUsers: BoardUser[] = [];
	boardUsers$: Observable<BoardUser[] | undefined>;
	boardUsersSub: Subscription | undefined;
	boardUsersInfo: BoardUsersInfo;
	boardUsersInfo$: Observable<BoardUsersInfo | undefined>;
	boardUsersInfoSub: Subscription;
	currentDeviceCommands: Command[];
	currentDeviceCommands$: Observable<Command[] | undefined>
	currentDeviceCommandsSub: Subscription;
	boardUsersLoading$: Observable<boolean | undefined>;
	boardUsersLoadingSub: Subscription | undefined;
	boardUserDeleted$: Observable<boolean | undefined>;
	boardUserDeletedSub: Subscription | undefined;
	boardUsersDeleted$: Observable<boolean | undefined>;
	boardUsersDeletedSub: Subscription | undefined;

	commandsAutomations: ConnectedAutomationsCommand[];
	connectedAutomation: ConnectedAutomations[];

	connectedAutomationsCommands$: Observable<ConnectedAutomationsCommand[] | undefined>;
	connectedAutomationsCommandsSub: Subscription;

	deviceInfo: DeviceInfo;
	deviceInfo$: Observable<DeviceInfo | undefined>;
	deviceInfoSub: Subscription | undefined;

	paging$: Observable<ItemsPagination | undefined>;
	pagingSub: Subscription;
	paginatorSub: Subscription;
	loading: boolean;
	device$: Observable<Device | undefined>;
	deviceSub: Subscription | undefined;
	loadingMemory = true;

	taskRunning: boolean;
	taskRunning$: Observable<boolean>;
	taskRunningSub: Subscription | undefined;
	groupsAll$: Observable<CAGroup[] | undefined>;
	groupsAllSub: Subscription | undefined;
	listGroup: CAGroup[];

	prevRunning = false;

	online: boolean;
	deviceStatus: DeviceStatus;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;

	pageSize = BOARD_USERS_DEFAULT_PAGE_SIZE;
	pageSizeOptions = BOARD_USERS_PAGE_SIZE_OPTIONS;
	paging: PaginationParams = {
		size: BOARD_USERS_DEFAULT_PAGE_SIZE,
		page: 1,
		// sort: BOARD_USERS_DEFAULT_SORT_COLUMN,
		// order: BOARD_USERS_DEFAULT_SORT_COLUMN_DIRECTION,
	};
	resultLength: number;
	ref: DynamicDialogRef | undefined;

	items: MenuItem[] | undefined;

	selectionKeys = {};

	filterGroup: FormGroup;
	filterSub: Subscription;
	functionList: any[];
	typeList: any[];
	groupList: any[];
	temporaryList: any[];
	quickEasyList: any[];

	passwordSupport: boolean;
	passwordVerify: boolean;
	isTechnician: boolean;
	isImpersMode: boolean;
	deviceFeature$: Observable<DeviceFeature[] | undefined>;
	deviceFeatureSub: Subscription | undefined;
	passwordVerify$: Observable<boolean | undefined>;
	passwordVerifySub: Subscription | undefined;
	isTechnician$: Observable<boolean | undefined>;
	isTechnicianSub: Subscription | undefined;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	needResync: boolean;
	needResync$: Observable<boolean | undefined>;
	needResyncSub: Subscription | undefined;

	boardUsersListsResp: BoardUsersListsRespData;
	boardUsersListsResp$: Observable<BoardUsersListsRespData | undefined>;
	boardUsersListsRespSub: Subscription | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	screenWidth: number;
	MIN_WD_COL4_MTMA = StandardDesignParameters.MIN_WD_COL4_MTMA;

	constructor(
		private store: Store<AppState>,
		public dialogService: DialogService,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
		this.boardUsers$ = this.store.select(selectCurrentDeviceBoardUsers);
		this.boardUsersInfo$ = this.store.select(selectCurrentDeviceBoardUsersInfo);
		this.boardUsersLoading$ = this.store.select(selectBoardUsersLoading);
		this.currentDeviceCommands$ = this.store.select(selectCurrentDeviceCommands);
		this.device$ = this.store.select(selectCurrentDevice);
		this.connectedAutomationsCommands$ = this.store.select(selectConnectedAutomationsCommands);
		this.taskRunning$ = this.store.select(selectBoardUsersTaskRunning);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
		this.groupsAll$ = this.store.select(selectGroupsAll);
		this.deviceInfo$ = this.store.select(selectCurrentDeviceInfo);
		this.boardUserDeleted$ = this.store.select(selectBoardUserDeleted);
		this.boardUsersDeleted$ = this.store.select(selectBoardUsersDeleted);
		this.acquiredBoardUser$ = this.store.select(selectAcquiredBoardUser);
		this.deviceFeature$ = this.store.select(selectCurrentDeviceFeatures);
		this.passwordVerify$ = this.store.select(selectPasswordValid);
		this.isTechnician$ = this.store.select(selectRoleExplainedTechnician);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
		this.needResync$ = this.store.select(selectNeedResync);
		this.boardUsersListsResp$ = this.store.select(selectBoardUsersListsRespData);
	}

	ngOnInit(): void {
		this.selectionKeys = {};
		this.subscribeAll();
		this.setOnPagingChanges();
		this.addBoardUserMenu();
		this.onResize();
		this.generateBuTypeList();
		this.generateBuFunctionList();
		this.generateTemporaryList();
		this.generateQuickEasyList();
		this.initFormGroup();
	}

	initFormGroup(): void {
		// Evita subscription duplicate se il form filtri viene ricreato.
		this.filterSub?.unsubscribe();
		this.filterGroup = new FormGroup({
			'nameFilter': new FormControl(''),
			'type': new FormControl(this.typeList !== undefined && this.typeList?.length > 0 ? this.typeList[0] : null),
			'function': new FormControl(this.functionList !== undefined && this.functionList?.length > 0 ? this.functionList[0] : null),
			'group': new FormControl(this.groupList !== undefined && this.groupList?.length > 0 ? this.groupList[0] : null),
			'temporary': new FormControl(this.temporaryList !== undefined && this.temporaryList?.length > 0 ? this.temporaryList[0] : null),
			'quickeasy': new FormControl(this.quickEasyList !== undefined && this.quickEasyList?.length > 0 ? this.quickEasyList[0] : null),
		});
		this.filterSub = this.filterGroup.valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			setTimeout(() => {
				this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'board_users_change_filter', params: { page_title: 'Device' } }));
			}, 2000);
			this.filterList();
		});
	}

	subscribeAll() {
		this.deviceInfoSub = this.deviceInfo$.pipe(filter(d => !!d))
			.subscribe(currentDeviceInfo => {
				this.deviceInfo = currentDeviceInfo;
			});
		this.boardUsersSub = combineLatest([
			this.deviceModel$,
			this.boardUsers$,
		])?.subscribe(([deviceModel, boardUsers]) => {
			if (deviceModel) {
				this.deviceModel = deviceModel;
			}
			if (boardUsers) {
				this.boardUsers = boardUsers;
			}
			if (this.deviceModel && boardUsers) {
				this.boardUsersTree = new BoardUsersTree(boardUsers, this.deviceModel.BoardClass);
				this.boardsList = this.boardUsersTree.getNodes();
				this.boards = this.boardsList;
				this.selectionKeys = {};
				// Dopo edit/delete/sync boardUsers$ emette di nuovo: aggiorniamo l'albero
				// ma NON ricreiamo il form, altrimenti i filtri (nome, tipo, gruppo, ecc.) tornano ai default.
				if (this.filterGroup) {
					this.filterList();
				} else {
					this.initFormGroup();
				}
			}
			if (this.isRbe24230() && this.isFunctionControlAccessSuppor()) {
				this.store.dispatch(DeviceActions.getGroupsAll());
			}
		});
		this.boardUsersInfoSub = this.boardUsersInfo$.subscribe(boardUsersInfo => {
			this.boardUsersInfo = boardUsersInfo;
			this.loadingMemory = false;
			this.generateBuFunctionList();
		});
		this.boardUsersLoadingSub = this.boardUsersLoading$.subscribe(loading => {
			this.loading = loading;
		});
		this.paging$ = this.store.select(selectBoardUsersItemsPagination);
		this.currentDeviceCommandsSub = this.currentDeviceCommands$.subscribe(currentDeviceCommands => {
			this.currentDeviceCommands = currentDeviceCommands;
		});
		this.deviceSub = this.device$.pipe(filter(d => !!d))
			.subscribe(currentDevice => {
				if (currentDevice !== undefined) {
					this.connectedAutomation = currentDevice.ConnectedAutomations;
				} else {
					this.connectedAutomation = [];
				}
			});
		this.connectedAutomationsCommandsSub = this.connectedAutomationsCommands$.subscribe(
			commandsAutomations => {
				this.commandsAutomations = commandsAutomations;
			}
		);
		this.taskRunningSub = this.taskRunning$.subscribe(taskRunning => {
			this.taskRunning = taskRunning;
			if (taskRunning === true) {
				this.prevRunning = true;
			} else {
				if (this.prevRunning) {
					this.reloadBoardUsers();
				}
			}
		});
		this.deviceStatusSub = this.deviceStatus$.subscribe(deviceStatus => {
			this.deviceStatus = deviceStatus;
			if (this.deviceStatus !== undefined) {
				this.online = deviceStatus.Online;
			}
		});
		this.groupsAllSub = this.groupsAll$.subscribe(listGroup => {
			this.listGroup = listGroup;
			this.generateGroupList();
		});
		this.boardUserDeletedSub = this.boardUserDeleted$.subscribe(boardUserDeleted => {
			if (boardUserDeleted) {
				// this.loadingMemory = true;
				this.loading = true;
				setTimeout(() => {
					this.reloadBoardUsers();
				}, 1000);
			}
		});
		this.acquiredBoardUserSub = this.acquiredBoardUser$.subscribe(acquiredBoardUser => {
			if (acquiredBoardUser !== undefined && acquiredBoardUser.Position !== undefined) {
				this.editBoardUserAquire(acquiredBoardUser);
			}
		});
		this.deviceFeatureSub = this.deviceFeature$.subscribe(deviceFeatures => {
			const fea = deviceFeatures.find(fe => fe.Name === 'password');
			if (fea !== undefined) {
				this.passwordSupport = true;
			}
		});
		this.passwordVerifySub = this.passwordVerify$.subscribe(passwordVerify => {
			this.passwordVerify = passwordVerify;
			// if (this.passwordVerify) {
			// 	this.toogleOpenPassword();
			// }
		});
		this.isTechnicianSub = this.isTechnician$.subscribe((isTechnician => {
			this.isTechnician = isTechnician;
		}));
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.needResyncSub = this.needResync$.subscribe((needResync) => {
			this.needResync = needResync;
		});
		this.boardUsersListsRespSub = this.boardUsersListsResp$?.subscribe(
			(boardUsersListsResp) => {
				if (boardUsersListsResp) {
					this.boardUsersListsResp = boardUsersListsResp;
				}
			}
		);
	}

	ngOnDestroy(): void {
		this.boardUsersSub?.unsubscribe();
		this.boardUsersInfoSub?.unsubscribe();
		this.deviceSub?.unsubscribe();
		this.connectedAutomationsCommandsSub?.unsubscribe();
		this.taskRunningSub?.unsubscribe();
		this.deviceStatusSub?.unsubscribe();
		this.groupsAllSub?.unsubscribe();
		this.deviceInfoSub?.unsubscribe();
		this.filterSub?.unsubscribe();
		this.boardUserDeletedSub?.unsubscribe();
		this.boardUsersDeletedSub?.unsubscribe();
		this.acquiredBoardUserSub?.unsubscribe();
		this.deviceFeatureSub?.unsubscribe();
		this.passwordVerifySub?.unsubscribe();
		this.isTechnicianSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.needResyncSub?.unsubscribe();
		this.boardUsersListsRespSub?.unsubscribe();
	}

	addBoardUserMenu(): void {
		this.items = [{
			label: this.translate.instant('MANUAL_ADD'), icon: 'pi cm-configuration',
			command: () => {
				this.addManualBoardUser();
			}
		},
		{
			label: this.translate.instant('LOCAL_ACQUIRE'), icon: 'pi cm-reload',
			command: () => {
				this.addAcquireBoardUser();
			}
		}]
	}

	addManualBoardUser(): void {
		this.store.dispatch(DeviceActions.boardUserDialogReset());
		this.ref = this.dialogService.open(BoardUserDialogComponent, {
			header: this.translate.instant('MANUAL_ADD') + ' ' + this.translate.instant('USER_DEVICE').toLowerCase(),
			width: '65vw',
			breakpoints: { '1500px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {}
		});
	}

	addAcquireBoardUser(): void {
		this.store.dispatch(DeviceActions.resetBoarduserAcquire());
		this.ref = this.dialogService.open(AcquireBoardUserDialogComponent, {
			header: this.translate.instant('ACQUIRE_CODE') + ' ' + this.translate.instant('USER_DEVICE').toLowerCase(),
			width: '65vw',
			breakpoints: { '1500px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {}
		});
	}

	editBoardUser(boardUserTree: any): void {
		const boardUserNode = boardUserTree.node;
		this.store.dispatch(DeviceActions.boardUserDialogReset());
		this.ref = this.dialogService.open(BoardUserDialogComponent, {
			header: this.translate.instant('MANUAL_EDIT') + ' ' + this.translate.instant('USER_DEVICE').toLowerCase(),
			width: '65vw',
			breakpoints: { '1400px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				deviceModel: this.deviceModel,
				boardUsersInfo: this.boardUsersInfo,
				boardUser: boardUserNode.data,
				isCodeGroup: boardUserNode.isCodeGroup,
			}
		});
		/* ref.afterClosed().pipe(filter(res => !!res)).subscribe(res => {
			 this.reloadBoardUsers();
		}); */
	}

	editBoardUserAquire(boardUser: BoardUser): void {
		this.store.dispatch(DeviceActions.boardUserDialogReset());
		this.ref = this.dialogService.open(BoardUserDialogComponent, {
			header: this.translate.instant('ACQUIRE_BOARD_USER'),
			width: '65vw',
			breakpoints: { '1400px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				deviceModel: this.deviceModel,
				boardUsersInfo: this.boardUsersInfo,
				boardUser: boardUser,
				isCodeGroup: false,
			}
		});
		/* ref.afterClosed().pipe(filter(res => !!res)).subscribe(res => {
			 this.reloadBoardUsers();
		}); */
	}


	deleteBoardUser(boardUser: BoardUser): void {
		let headerStr = "";
		switch (boardUser.Type) {
			case ECodeTypes.CODE_TYPE_KEYBOARD:
				headerStr = this.translate.instant("RADIOCOMANDO_KEYBOARD");
				break;
			case ECodeTypes.CODE_TYPE_TRANSPONDER:
				headerStr = this.translate.instant("TRANSPONDER");
				break;
			default:
				headerStr = this.translate.instant("BOARD_USER");
		}
		const deleteBUConfDialog = this.dialogService.open(CommonCustomConfirmDialogComponent, {
			header: this.translate.instant('DELETE') + " " + headerStr,
			contentStyle: { overflow: 'auto' },
			data: {
				icon: 'cm-alert',
				row1: 'DELETE_MESSAGE_WARNING',
				classAcceptButton: 'p-button-danger',
			}
		});
		deleteBUConfDialog.onClose.subscribe((accepted: boolean) => {
			if (accepted) {
				this.store.dispatch(DeviceActions.deleteBoardUser({position: boardUser.Position, code: boardUser.Code}));
			}
		});
	}

	isFullMemory(): boolean {
		if (this.boardUsersInfo !== undefined && this.boardUsersInfo.Used >= this.boardUsersInfo.Max) {
			return true;
		}
		return false;
	}

	getInfo(): void {
		this.store.dispatch(DeviceActions.getBoardUsersInfo({}));
	}

	getValueMemory(): number {
		if (this.boardUsersInfo) {
			const used = this.boardUsersInfo.Used;
			const max = this.boardUsersInfo.Max;
			const percentageValue = used / max * 100;
			return parseInt(percentageValue.toFixed(0));
		} else {
			return 0;
		}
	}

	getIconBoardUser(boardUserTree: any): string {
		if (this.boardUsersInfo !== undefined && boardUserTree !== undefined) {
			const boardUserNode = boardUserTree.node;
			return getBoardUserIcon(boardUserNode.data, this.boardUsersInfo.Types, boardUserTree.level > 0);
		}
		return '';
	}

	isRbe4(): boolean {
		return this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.RBE4 || this.deviceModel.Id === EDeviceModel.RBE4030 ||
			this.deviceModel.Id === EDeviceModel.RBE4230 || this.deviceModel.Id === EDeviceModel.GEN_RBE4);
	}

	isRbe24230(): boolean {
		return this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.RBE24230 || this.deviceModel.Id === EDeviceModel.RBE230 ||
			this.deviceModel.Id === EDeviceModel.RBE24 || this.deviceModel.Id === EDeviceModel.GEN_RBE24230);
	}

	isFunctionControlAccessSuppor(): boolean {
		return this.compareVersions(this.deviceInfo?.FwVersion, MINFWVER_ACSCHEDULES_RBE24);
	}

	compareVersions(ver1: string, ver2: string): boolean {
		// prevent missing versions v1 and/or v2
		if (!ver1) return false;
		if (!ver2) return true;

		const a = ver1.split('.').map(Number);
		const b = ver2.split('.').map(Number);

		const maxLength = Math.max(a.length, b.length);

		for (let i = 0; i < maxLength; i++) {
			const num1 = a[i] || 0; // if an element is missing, use 0 (default)
			const num2 = b[i] || 0;

			if (num1 > num2) return true;
			if (num1 < num2) return false;
		}

		return true; // if all parts are equal
	}

	isQuickEasy(boardUser: BoardUser): boolean {
		if ((boardUser.State & (1 << 8)) > 0) {
			return true;
		}
		return false;
	}

	getDate(date: string): Date {
		const dateChange = moment.utc(date)
		return dateChange.toDate();
	}

	getTypeDescription(boardUser: BoardUser): string {
		if (boardUser.Type === ECodeTypes.CODE_TYPE_KEYBOARD) {
			return this.translate.instant("RADIOCOMANDO_KEYBOARD") + ' - ' + kbCodeToHumanReadable(boardUser.Code);
		}
		if (boardUser === undefined || boardUser.TypeDescription === undefined || boardUser.TypeDescription === null || boardUser.TypeDescription.length <= 0) {
			return '-';
		}
		return boardUser.TypeDescription;
	}

	getFunctionDescription(boardUser: BoardUser): string {
		if (this.boardUsersInfo && this.boardUsersInfo.ControlItem && this.boardUsersInfo.ControlItem.Items) {
			if (this.isRbe4()) {
				const foundMode = this.boardUsersInfo.ControlItem.Items.find(i => i.Value === boardUser.Mode);
				if (foundMode) {
					for (const command of this.currentDeviceCommands) {
						if (foundMode.Value === 16 && command.Id === 144) {
							return command.Default === command.Description ? command.Description : command.Description + ' (' + foundMode.Description + ')';
						}
						if (foundMode.Value === 32 && command.Id === 145) {
							return command.Default === command.Description ? command.Description : command.Description + ' (' + foundMode.Description + ')';
						}
						if (foundMode.Value === 64 && command.Id === 146) {
							return command.Default === command.Description ? command.Description : command.Description + ' (' + foundMode.Description + ')';
						}
						if (foundMode.Value === 128 && command.Id === 147) {
							return command.Default === command.Description ? command.Description : command.Description + ' (' + foundMode.Description + ')';
						}
					}
				}
			} else if (this.isRbe24230()) {
				let mode = boardUser.Mode;
				let text = '';
				for (let i = 7; i >= 4; i--) {
					if (Math.floor(mode / (2 ** i)) === 1) {
						const cmd = this.boardUsersInfo.ControlItem.Items.find(item => item.Value === (2 ** i));
						if (cmd) {
							for (const command of this.currentDeviceCommands) {
								if ((cmd.Value === 16 && command.Id === 144) || (cmd.Value === 32 && command.Id === 145) ||
									(cmd.Value === 64 && command.Id === 146) || (cmd.Value === 128 && command.Id === 147)) {
									const txt = command.Default === command.Description ? command.Description : command.Description + ' (' + cmd.Description + ')';
									if (text === '') {
										text = txt;
									} else {
										text = txt + ', ' + text;
									}
								}
							}
						}
						mode = mode - (2 ** i);
					}
				}
				// AUTOMATION 1
				if (boardUser.Autom1Cmd && this.commandsAutomations !== undefined && this.connectedAutomation !== undefined) {
					const automComm = this.commandsAutomations.find(c => c.CrpItemId === 1);
					if (automComm !== undefined && this.connectedAutomation !== undefined) {
						const automa = this.connectedAutomation.find(aut => aut.CrpItemId === 1);
						const comm = automComm.Commands.find(c => c.Id === boardUser.Autom1Cmd);
						if (automa !== undefined) {
							const txt = automa.Name + ' - ' + comm.Description;
							if (text === '') {
								text = txt;
							} else {
								text = text + ', ' + txt;
							}
						}
					}
				}
				// AUTOMATION 2
				if (boardUser.Autom2Cmd && this.commandsAutomations !== undefined && this.connectedAutomation !== undefined) {
					const automComm = this.commandsAutomations.find(c => c.CrpItemId === 2);
					if (automComm !== undefined && this.connectedAutomation !== undefined) {
						const automa = this.connectedAutomation.find(aut => aut.CrpItemId === 2);
						const comm = automComm.Commands.find(c => c.Id === boardUser.Autom2Cmd);
						if (automa !== undefined) {
							const txt = automa.Name + ' - ' + comm.Description;
							if (text === '') {
								text = txt;
							} else {
								text = text + ', ' + txt;
							}
						}
					}
				}
				// AUTOMATION 3
				if (boardUser.Autom3Cmd && this.commandsAutomations !== undefined && this.connectedAutomation !== undefined) {
					const automComm = this.commandsAutomations.find(c => c.CrpItemId === 3);
					if (automComm !== undefined && this.connectedAutomation !== undefined) {
						const automa = this.connectedAutomation.find(aut => aut.CrpItemId === 3);
						const comm = automComm.Commands.find(c => c.Id === boardUser.Autom3Cmd);
						if (automa !== undefined) {
							const txt = automa.Name + ' - ' + comm.Description;
							if (text === '') {
								text = txt;
							} else {
								text = text + ', ' + txt;
							}
						}
					}
				}
				// AUTOMATION 4
				if (boardUser.Autom4Cmd && this.commandsAutomations !== undefined && this.connectedAutomation !== undefined) {
					const automComm = this.commandsAutomations.find(c => c.CrpItemId === 4);
					if (automComm !== undefined && this.connectedAutomation !== undefined) {
						const automa = this.connectedAutomation.find(aut => aut.CrpItemId === 4);
						const comm = automComm.Commands.find(c => c.Id === boardUser.Autom4Cmd);
						if (automa !== undefined) {
							const txt = automa.Name + ' - ' + comm.Description;
							if (text === '') {
								text = txt;
							} else {
								text = text + ', ' + txt;
							}
						}
					}
				}
				return text;
			} else {
				const foundMode = this.boardUsersInfo.ControlItem.Items.find(i => i.Value === boardUser.Mode);
				if (foundMode) {
					return foundMode.Description;
				}
			}
		}
		return '';
	}

	getGroup(boardUser: BoardUser): string {
		if (boardUser.GroupId === null || boardUser.GroupId === undefined) {
			return '-';
		}
		const group = this.listGroup.find(gr => gr.Id === boardUser.GroupId);
		return group !== undefined ? group.Name : '-';
	}

	isTemporaryAccess(boardUser: BoardUser): boolean {
		if ((boardUser.State & (1 << 10)) > 0 && boardUser.DateFrom !== undefined && boardUser.DateTo !== undefined && boardUser.DateFrom !== null && boardUser.DateTo !== null
			&& moment(boardUser.DateFrom).isValid() && moment(boardUser.DateTo).isValid()) // Check First bit active (quick&Easy or not)
			return true;
		else
			return false;
	}

	setOnPagingChanges(): void {
		this.pagingSub = this.paging$.pipe(filter(p => !!p))
			.subscribe(
				paging => {
					this.resultLength = paging.TotalCount;
				}
			);
	}

	reloadBoardUsers(): void {
		this.getInfo();
		this.paging.size = 100000;
		this.paging.page = 1;
		this.store.dispatch(DeviceActions.getBoardusers({ paging: this.paging }));
	}

	generateBuTypeList(): void {
		this.typeList = [];
		this.typeList.push({ Id: 0, Label: 'ALL' });
		this.typeList.push({ Id: ECodeTypes.CODE_TYPE_KEYBOARD, Label: 'RADIOCOMANDO_KEYBOARD' });
		this.typeList.push({ Id: ECodeTypes.CODE_TYPE_TRANSPONDER, Label: 'RADIOCOMANDO_TRANSPONDER_NEW' });
		this.typeList.push({ Id: ECodeTypes.CODE_TYPE_TOP, Label: 'RADIOCOMANDO_TOP' });
		this.typeList.push({ Id: ECodeTypes.CODE_TYPE_TAM, Label: 'RADIOCOMANDO_TAM' });
		this.typeList.push({ Id: ECodeTypes.CODE_TYPE_ROLLING, Label: 'RADIOCOMANDO_ROLLING' });
		this.typeList.push({ Id: ECodeTypes.CODE_TYPE_TWIN_TTS_FIXED, Label: 'RADIOCOMANDO_TWIN_TTS_FIXED' });
	}

	generateGroupList(): void {
		this.groupList = [];
		this.groupList.push({ Id: 0, Label: 'ALL' });
		this.groupList.push({ Id: -1, Label: 'WITHOUT_GROUP' });
		for (const group of this.listGroup) {
			this.groupList.push({ Id: group.Id, Label: group.Name });
		}
	}

	generateTemporaryList(): void {
		this.temporaryList = [];
		this.temporaryList.push({ Id: 0, Label: 'ALL' });
		this.temporaryList.push({ Id: 1, Label: 'TEMPORARY_USER' });
		this.temporaryList.push({ Id: -1, Label: 'NOT_TEMPORARY_USER' });
	}

	generateQuickEasyList(): void {
		this.quickEasyList = [];
		this.quickEasyList.push({ Id: 0, Label: 'ALL' });
		this.quickEasyList.push({ Id: 1, Label: 'QUICK_EASY_USER' });
		this.quickEasyList.push({ Id: -1, Label: 'NOT_QUICK_EASY_USER' });
	}

	generateBuFunctionList(): void {
		this.functionList = [];
		this.functionList.push({ Id: 0, Label: 'ALL' });
		if (this.boardUsersInfo !== undefined && this.boardUsersInfo.ControlItem !== undefined && this.boardUsersInfo.ControlItem.Items !== undefined)
			for (const itemBu of this.boardUsersInfo.ControlItem.Items) {
				let addStr = '';
				switch (itemBu.Value) {
					case 256:
					case 257:
					case 258:
					case 259:
					case 10005:
						addStr = this.translate.instant('AUTOMATION') + ' A: ';
						break;
					case 260:
					case 261:
					case 262:
					case 263:
					case 10021:
						addStr = this.translate.instant('AUTOMATION') + ' B: ';
						break;
					case 264:
					case 265:
					case 266:
					case 267:
					case 10037:
						addStr = this.translate.instant('AUTOMATION') + ' C: ';
						break;
					case 268:
					case 269:
					case 270:
					case 271:
					case 10053:
						addStr = this.translate.instant('AUTOMATION') + ' D: ';
						break;
				}
				this.functionList.push({ Id: itemBu.Value, Label: addStr + itemBu.Description });
			}
	}

	filterList(): void {
		let filterList = this.boardsList;
		// nameFilter
		const nameFilter = this.f.nameFilter.value;
		if (nameFilter !== undefined && nameFilter !== '') {
			filterList = filterList.filter(bo => this.isNameFilter(bo, nameFilter) || this.isCodeFilter(bo, nameFilter));
		}
		// type
		const typeFilter = this.f.type.value?.Id;
		if (this.f.type.value?.Id !== 0) {
			filterList = filterList.filter(bo => this.isTypeFilter(bo, typeFilter));
		}
		// function
		const functionFilter = this.f.function.value?.Id;
		if (this.f.function.value?.Id !== 0) {
			filterList = filterList.filter(bo => this.isFunctionFilter(bo, functionFilter));
		}
		// Group
		const groupFilter = this.f.group.value?.Id;
		if (groupFilter !== 0 && groupFilter !== -1) {
			filterList = filterList.filter(bo => this.isGroupFilter(bo, groupFilter));
		} else if (groupFilter === -1) {
			filterList = filterList.filter(bo => this.isNotGroupFilter(bo));
		}
		// Temporary
		const temporaryFilter = this.f.temporary.value?.Id;
		if (temporaryFilter === 1) {
			filterList = filterList.filter(bo => this.isTemporaryFilter(bo));
		} else if (temporaryFilter === -1) {
			filterList = filterList.filter(bo => !this.isTemporaryFilter(bo));
		}
		// Quick & Easy
		const quickeasyFilter = this.f.quickeasy.value?.Id;
		if (quickeasyFilter === 1) {
			filterList = filterList.filter(bo => this.isQuickEasyFilter(bo));
		} else if (quickeasyFilter === -1) {
			filterList = filterList.filter(bo => !this.isQuickEasyFilter(bo));
		}
		this.boards = filterList;
	}

	isNameFilter(bo: TreeNode, filter: string): boolean {
		if (bo.data.GroupName?.toLowerCase().includes(filter.toLowerCase())) {
			return true;
		}
		if (bo.data.Name?.toLowerCase().includes(filter.toLowerCase())) {
			return true;
		}
		if (bo.children?.length > 0 && bo.children?.filter(chil => chil.data?.Name?.toLowerCase().includes(filter.toLowerCase())).length > 0) {
			return true;
		}
		return false;
	}

	isCodeFilter(bo: TreeNode, filter: string): boolean {
		if (bo.data.Type && bo.data.Code && bo.data.Type === ECodeTypes.CODE_TYPE_KEYBOARD && kbCodeToHumanReadable(bo.data.Code).toLowerCase().includes(filter.toLowerCase())) { // convert keyboard code to human readable
			return true;
		}
		if (bo.data.Code?.toLowerCase().includes(filter.toLowerCase())) {
			return true;
		}
		if (bo.children?.length > 0 && bo.children?.filter(chil => chil.data?.Code?.toLowerCase().includes(filter.toLowerCase())).length > 0) {
			return true;
		}
		return false;
	}

	isTypeFilter(bo: TreeNode, filter: number): boolean {
		if (bo.data.Type === filter) {
			return true;
		}
		return false;
	}

	isFunctionFilter(bo: TreeNode, filter: number): boolean {
		if (bo.data.functionIdList?.includes(filter)) {
			return true;
		}
		if (bo.children?.length > 0 && bo.children?.filter(chil => chil.data?.functionIdList?.includes(filter)).length > 0) {
			return true;
		}
		return false;
	}


	isGroupFilter(bo: TreeNode, filter: number): boolean {
		if (bo.data.GroupId === filter) {
			return true;
		}
		if (bo.children?.length > 0 && bo.children?.filter(chil => chil.data?.GroupId === filter).length > 0) {
			return true;
		}
		return false;
	}

	isNotGroupFilter(bo: TreeNode): boolean {
		if (bo.data?.GroupId === null) {
			return true;
		}
		if (bo.children?.length > 0 && bo.children?.filter(chil => chil.data?.data?.GroupId === null).length > 0) {
			return true;
		}
		return false;
	}


	isTemporaryFilter(bo: TreeNode): boolean {
		if (this.isTemporaryAccess(bo.data)) {
			return true;
		}
		if (bo.children?.length > 0 && bo.children?.filter(chil => this.isTemporaryAccess(chil.data)).length > 0) {
			return true;
		}
		return false;
	}



	isQuickEasyFilter(bo: TreeNode): boolean {
		if (this.isQuickEasy(bo.data)) {
			return true;
		}
		if (bo.children?.length > 0 && bo.children?.filter(chil => this.isQuickEasy(chil.data)).length > 0) {
			return true;
		}
		return false;
	}


	deleteSelected(): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('DELETE_SELECTED'),
			message: this.translate.instant('DELETE_SELECTED_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.deleteSelectedConfirm();
			},
			reject: () => {
			}
		});
	}

	isSelectedKey(): boolean {
		const arrayKey = Object.keys(this.selectionKeys);
		return arrayKey.length > 0;
	}

	deleteSelectedConfirm(): void {
		const arrayKey = Object.keys(this.selectionKeys);
		const boardUsers = [];
		for (const key of arrayKey) {
			const numb = Number(key);
			if (numb !== null) {
				const bu = this.boardUsers.find(bu => bu.Position === numb);
				if (bu !== null && bu !== undefined &&
					bu.Position !== undefined && bu.Position !== null &&
					bu.Code !== undefined && bu.Code !== null) {
					boardUsers.push({ Position: bu.Position, Code: bu.Code });
				}
			}
		}
		if (boardUsers.length > 0) {
			this.store.dispatch(DeviceActions.deleteBoardUserSelected({ boardUsers }));
		}
	}

	/*loadBoardUsers(event: TableLazyLoadEvent) {
		this.loading = true;

		this.paging = pageSortChange(this.paging, event);

		this.reloadBoardUsers();
	}*/


	get f(): any {
		return this.filterGroup.controls;
	}

	syncData(): void {
		this.store.dispatch(DeviceActions.syncBoardUsers());
	}

	exportList(): void {
		this.store.dispatch(DeviceBoardusersActions.resetBoarduserListDialog());
		this.ref = this.dialogService.open(BoardUsersExportListDialogComponent, {
			header: this.translate.instant('EXPORT_LIST'),
			width: '70vw',
			breakpoints: { '1120px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				versionLists: this.boardUsersListsResp ? this.boardUsersListsResp.Version : '',
				listUpdating: false
			}
		});
	}

	deleteBoardUsers(): void {
		let message = this.translate.instant('NEW_DELETE_ALL_BOARD_USERS_WARNING');
		if (this.isRbe24230()) {
			message = this.translate.instant('DELETE_ALL_BOARD_USERS_NO_Q&E_WARNING');
		}
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('DELETE_ALL'),
			message: message,
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(DeviceActions.deleteAllBoardUsers());
			},
			reject: () => {
			}
		});
	}

	isAccess(): boolean {
		if (!this.passwordSupport) {
			return true;
		}
		if (this.passwordVerify) {
			return true;
		}
		if (!this.isTechnician && !this.isImpersMode) {
			return true;
		}
		return false;
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underTablet(): boolean {
		return StandardPageLayout.underTablet(this.screenWidth);
	}

	actionLayout(position: string): string {
		return StandardMtmaLayout.actionLayout(this.screenWidth, position);
	}

	col4Responsive(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}
}
